const PREFIX = 'corecry:bot-preview:v1:';
const TTL = 24 * 60 * 60 * 1000;

export function readBotPreview(identity) {
    if (!identity) return [];
    try {
        const value = JSON.parse(localStorage.getItem(PREFIX + identity) || 'null');
        if (!value || value.identity !== identity || !Array.isArray(value.bots) || !Number.isFinite(value.savedAt) ||
            Date.now() < value.savedAt || Date.now() - value.savedAt > TTL) return [];
        return value.bots.filter(bot => typeof bot.id === 'string' && typeof bot.name === 'string');
    } catch { return []; }
}

export function writeBotPreview(identity, bots) {
    if (!identity) return;
    try {
        const safe = bots.filter(bot => bot?.id != null).slice(0, 500).map(bot => ({
            id: String(bot.id), name: String(bot.botName || bot.name || 'Bot'),
            basic: { pair: String(bot.basic?.pair || bot.pair || '') },
            status: String(bot.status || ''), favorite: Boolean(bot.favorite),
        }));
        const value = JSON.stringify({ identity, savedAt: Date.now(), bots: safe });
        if (value.length <= 200000) localStorage.setItem(PREFIX + identity, value);
    } catch { /* Optional local presentation snapshot. */ }
}

export function clearBotPreviews() {
    try {
        for (let i = localStorage.length - 1; i >= 0; i--) {
            const key = localStorage.key(i);
            if (key?.startsWith(PREFIX)) localStorage.removeItem(key);
        }
    } catch { /* Storage is optional. */ }
}
